const HasRole = ({ roles, children, exclusion }) => {
	return children
}

export default HasRole
